// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/AiCredits_PacksAvailableInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * AiCredits_PacksAvailableInput — query params for
 * GET /ai/credits/packs/available.
 *
 * Optional:
 *   franquia_id — when present, resolves that franchise's country STRICTLY
 *                 via findFranchiseCountryOrNull (D6): unset/unmapped country
 *                 or a country with no billing market yields an EMPTY catalog
 *                 (purchase_enabled=false, empty_reason='pais_sem_mercado') —
 *                 never a silent BR/BRL fallback. Must be a positive integer
 *                 when given. When absent, the catalog is pinned to the BR
 *                 default (no franchise to resolve).
 */
import { registerContract } from './validate'

export interface AiCredits_PacksAvailableInput {
franquia_id?: number
}

registerContract('AiCredits_PacksAvailableInput', {
  franquia_id: { type: 'number',  required: false },
})
